import React, { useEffect, useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './alert.scss'

const Alert = (props) => {

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(Boolean(props.show));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const toggle = () => {
    setShow(!show);
    if (typeof props.onClose === 'function')
      props.onClose();
  };
  
  return (
    <Modal className="custom-alert-modal" isOpen={show} toggle={toggle} {...props}>
        {
          props.title &&
          <ModalHeader toggle={toggle}>{props.title ?? ''}</ModalHeader>
        }
        <ModalBody>
          {props.message ?? ''}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle}>
            {props.CloseText || 'Close'}
          </Button>
        </ModalFooter>
      </Modal>
  )
}

export default Alert;